import classNames from 'classnames';
import { ReactNode } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { compoundManagementSlice, getSelectedCompoundVehicle } from '../../../reducers/compoundManagementSlice';
import { ColumnDefinition } from '../../../sharedComponents/table/SortedTableHeader';
import { CompoundVehicle } from '../../compoundManagement.types';

type CompoundManagementTableRowProps<TableColumnEnum extends string> = {
    vehicle: CompoundVehicle;
    highlight?: 'danger' | 'warning' | undefined;
    columnDefinition: ColumnDefinition<TableColumnEnum>[];
    children: (definition: TableColumnEnum) => ReactNode;
    selectionCell?: ReactNode;
};

export const CompoundManagementTableRow = <TableColumnEnum extends string>({
    vehicle,
    highlight = undefined,
    columnDefinition,
    children: renderRow,
    selectionCell,
}: CompoundManagementTableRowProps<TableColumnEnum>) => {
    const dispatch = useAppDispatch();
    const isRowSelected = useAppSelector((state) => getSelectedCompoundVehicle(state)?.id === vehicle.id);

    const handleRowClick = (event: React.MouseEvent<HTMLTableRowElement>) => {
        /* Ignore click events from inside a checkbox cell */
        const clickedElement = event.target as HTMLElement;
        const isCheckboxCell = clickedElement.closest('.table-checkbox');
        if (isCheckboxCell) {
            return;
        }

        if (isRowSelected) {
            dispatch(compoundManagementSlice.actions.deselectCompoundVehicle());
        } else {
            dispatch(compoundManagementSlice.actions.selectCompoundVehicle(vehicle));
        }
    };

    return (
        <tr className={classNames('cursor-pointer', { active: isRowSelected }, highlight)} onClick={handleRowClick}>
            {selectionCell}
            {columnDefinition.map((def) => {
                return <td key={def.column}>{renderRow(def.column)}</td>;
            })}
        </tr>
    );
};
